var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"d-flex border-none main-component"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2",on:{"click":function($event){return _vm.$emit('showComponentList')}}},[_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',[_c('span',{staticClass:"material-icons"},[_vm._v("list")])])
}]

export { render, staticRenderFns }